import {
  Component,
  Input,
  OnInit,
  ViewChild,
  AfterViewInit,
  QueryList,
  ViewChildren,
  ElementRef,
  AfterContentChecked
} from '@angular/core';
import { QuestionBase } from '../../domain/question.base';
import { QuestionComponent } from '../question.component';
import { FormGroup } from '@angular/forms';
import { ImageAsset, ImageAssetFactory, ImageAssetType } from '../../domain/card';
import { ScrollService } from '../scroll.service';

@Component({
  selector: `crds-question-textbox`,
  template: `
    <div *ngIf="show" [formGroup]="form">
      <!-- QUESTION LABLE -->
      <label *ngIf="question.label" class="form-label" [attr.for]="question.key"
        >{{ question.label }}
        <span *ngIf="question.required"> *</span>
        <crds-form-error *ngIf="isInvalid" [question]="question" [message]="question.errorMessage"></crds-form-error>
      </label>

      <!-- QUESTION INPUT -->
      <input
        [formControlName]="question.key"
        [id]="question.key"
        [type]="question['type'] || 'text'"
        (change)="onChange()"
        [ngStyle]="{ 'text-transform': this.question.forceUpper && 'uppercase' }"
        class="form-control mb-2"
        #textInput
      />

      <!-- QUESTION HINT -->
      <crds-question-hint [question]="question"></crds-question-hint>

      <!-- QUESTION IMAGE -->
      <div class="image-wrapper">
        <crds-image-asset [images]="images" [key]="question.key"></crds-image-asset>
      </div>
    </div>
  `
})
export class TextboxQuestionComponent extends QuestionComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() question: QuestionBase<string>;
  @ViewChild('textInput') input;
  type: string;
  images: ImageAsset[];
  imageAssetType = ImageAssetType;

  constructor(private imageAssetFactory: ImageAssetFactory, private scrollService: ScrollService) {
    super();
  }

  ngOnInit(): void {
    if (this.question.disabled === true && !this.show) {
      setTimeout(() => this.form.get(this.question.key).disable());
    }
    this.images = this.imageAssetFactory.create(this.question.image, this.form);
    this.scrollService.scrollObservable.subscribe(documentId => {
      if (documentId === this.question.key) {
        this.input.nativeElement.scrollIntoView();
      }
    });
  }

  /** Though we can force to uppercase using CSS, that doesn't change the actual value
   *  so when we leave the field, we also need to upperCase the value too
   */
  onChange() {
    if (this.question.forceUpper) {
      const field = this.form.get(this.question.key);
      if (field.value) {
        field.setValue(field.value.toUpperCase());
      }
    }
  }

  get isInvalid() {
    return this.form.get(this.question.key).touched && this.form.get(this.question.key).invalid;
  }

  get show() {
    const showIfQuestionPopulated = this.question.showIf ? this.showIf : true;
    return (
      (this.question.showIfPopulated !== true || this.value) && showIfQuestionPopulated && this.question.show !== false
    );
  }
}
